<template>
  <div class="content_box">
    <div class="login_banner">
      <img src="../../assets/login_banner.png" />
      <div class="logo"><img src="../../assets/logo.png" /></div>
    </div>
    <div class="main_content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="key" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="key" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  computed: {
    key() {
      return this.$route.path
    },
  }
}
</script>

<style>
body {
  margin: 0 !important;
}
.content_box{
    height: 100%;
    background-color: #fff;
     position: relative;
}
@media screen and (min-width: 1024px) {
  .content_box {
    width: 1024px;
    margin: auto;
  }
}
.login_banner {
  width: 100%;
  height: 160px;
  position: relative;
}

.login_banner img {
  width: 100%;
  height: 100%;
}

.logo {
  width: 100px;
  position: absolute;
  left: 12px;
  top: -7px;
}
.main_content {
  margin-top: -65px;
  background-color: #fff;
  padding: 10px;
  z-index: 999;
}
</style>